module.exports = __webpack_public_path__ + "static/img/favicon.ed390e0.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oncoscience/favicon.ico
// module id = 494
// module chunks = 1